//import { Component, OnInit } from '@angular/core';
//import { Router } from '@angular/router';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { AlertDialogService } from 'src/app/Services/Alert/alert.service';
import { PropertiesService } from 'src/app/Services/Properties/properties.service';
import { HttpRequestService } from 'src/app/Services/Http/http-request.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { CommonService } from 'src/app/Services/Common/common.service';
import { SearchService } from 'src/app/Services/search.service';
import { HttpClient } from '@angular/common/http';
import { CommonGridService } from 'src/app/Services/Common/grid.service';
import { jqxGridComponent } from 'jqwidgets-scripts/jqwidgets-ts/angular_jqxgrid';
import { MatDialog } from '@angular/material';
declare var $: any;
import * as XLSX from 'xlsx';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  constructor(private formBuilder: FormBuilder,
    private alert: AlertDialogService,
    private httpRequestService: HttpRequestService,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private property: PropertiesService,
    private datePipe: DatePipe,
    private searchService: SearchService,
    private gridService: CommonGridService,
    public dialog: MatDialog,
    public commonService: CommonService) { }
    WebAPImasteruri = this.property.WebAPIipAndPort.concat(this.property.BSSAPI);
    TotEmployee: string = "";
    TotCompany: string = "";
    Birthday: string = "";
    willDownload = false;
    progressBarShow: boolean = false;
    HeadList: any = [];
    items2: any;
    keys: any = [];
    //bar
    barchartlist: any;
  public barChartOptions: any = {
    scaleShowVerticalLines: false,
    responsive: true
  };
  public mbarChartLabels: string[];
  public barChartType: string = 'bar';
  public barChartLegend: boolean = true;

  public barChartData: any[];
  HtmlStrBar: string = "";
    
  ngOnInit() {
    // console.log('Dash URL: ' + this.router.url);
    this.getDashboard();
    
  }
  onFileChange(ev) {
    this.progressBarShow = true;
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev.target.files[0];
    reader.onload = (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary' });
      jsonData = workBook.SheetNames.reduce((initial, name) => {
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet);
        return initial;
      }, {});
      const dataString = JSON.stringify(jsonData);
      document.getElementById('output').innerHTML = dataString.slice(0, 300).concat("...");
      this.setDownload(dataString);
    }
    reader.readAsBinaryString(file);
  }
  setDownload(data) {
    this.progressBarShow = false;
    this.willDownload = true;
    setTimeout(() => {
      const el = document.querySelector("#download");
      el.setAttribute("href", `data:text/json;charset=utf-8,${encodeURIComponent(data)}`);
      el.setAttribute("download", 'xlsxtojson.json');
    }, 1000)
  }
  getDashboard(){
    this.GetDash().then((list: any) => {
      this.TotEmployee = list.result.Table1[0].TotEmployee;
      this.TotCompany = list.result.Table1[0].TotCompany;
      this.Birthday = list.result.Table1[0].Birthday;

      this.items2 = list.result.Table2;

      for (var key in list.result.Table2[0]) {
        this.HeadList.push(key);
      }
      // console.log(this.HeadList);
      for (let key in list.result.Table2) {
        this.keys.push({ key: key, value: list.result.Table2[key] });
      }

        //bar
        this.barchartlist = list.result.Table3;
        if(this.barchartlist.length>0){
          // this.mbarChartLabels = ['2012', '2013', '2014', '2015', '2016', '2017', '2018'];
          
                // this.barChartData = [
                //   { data: [55, 60, 75, 82, 56, 62, 80], label: 'Company A' },
                //   { data: [58, 55, 60, 79, 66, 57, 90], label: 'Company B' }
                // ];
          
                let jsonBar = list.result.Table3;
                let tempArrLabel: any = [];
                let tempArrLabel1: any = [];
                for (var key in jsonBar[0]) {
                  if (key != "Date") {
                    tempArrLabel.push({
                      key
                    });
                  }
          
                }
                // jsonBar.forEach(element => {
                //   tempArr2.push({data:[element.Days]})
                // });
                tempArrLabel.forEach(element => {
                  tempArrLabel1.push(element.key)
                });
                // this.mbarChartLabels = tempArrLabel.key;
                this.mbarChartLabels = tempArrLabel1;
          
          
          
                var fruits = new Array();
                let customsubMenuRate = new Array();
                let customsubMenuRate2;
                list.result.Table3.forEach(element => {
                  fruits = new Array();
                  for (let key in element) {
                    // console.log("      key:", key, "value:", element[key]);
                    if (key != "Date") {
                      fruits.push(element[key]);
                    }
                  }
                  customsubMenuRate2 = { data: fruits, label: element.Date };
                  customsubMenuRate.push(customsubMenuRate2);
                });
                console.log(customsubMenuRate);
          
                this.barChartData = customsubMenuRate;
                }
    });
  }

  public barchartClicked(e: any): void {
    this.getBarChartTable();
  }

  getBarChartTable() {
    let table = "";
    table += '<div class="table-responsive">';
    table += '<table class="table custom-table"><thead> <tr>'
    for (var key in this.barchartlist[0]) {
      table +='<th>'+key+'</th>';
    }
    // table += '<th>Branch</th><th>Value</th>';
    table += '</tr></thead><tbody>';
    this.barchartlist.forEach(element => {
      table += '<tr>';
      for (var key in this.barchartlist[0]) {
        table += '<td>' + element[key] + '</td>';
      }
      table += '</tr>';
    });
    // table += '<tr>';
    // table += '<td>' + label + '</td><td>' + value + '</td>';
    // table += '</tr>';
    table += '</tbody></table></div>';
    this.HtmlStrBar = table;
  }

  GetDash() {
    return new Promise((resolve, reject) => {
      this.httpRequestService.get(this.WebAPImasteruri + "/HR/Dashboard_Admin?UserID="+this.property.userId)
        .then((res: any) => {
          if (res.status == 200) {
            resolve(res);
          }
        }, (error) => {
          reject(error);
        });
    });
  }
}
